"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.native.help': 'Native knowledge is hidden from regular users but available for AI assistants',
};
